// <head> metadata for WebcastDbosTransactTypescript2Page (https://www.dbos.dev/webcast-dbos-transact-typescript-2).
// Kept apart from the page component so the router can load each page's code on its own.

import type { PageHead } from '@lib/head';

export const head: PageHead = {
  meta: [
    {
      title: 'Webcast: DBOS Transact for TypeScript 2.0',
    },
    {
      name: 'description',
      content:
        "Live webcast February 6: DBOS Architect Chuck Bear walks you through the open source DBOS Transact for TypeScript 2.0 library. He'll show you the easiest way to make TypeScript, Next.js, Node.js apps durable, observable, and scalable by default.",
    },
    {
      property: 'og:title',
      content: 'Webcast: DBOS Transact for TypeScript 2.0',
    },
    {
      property: 'og:description',
      content:
        "Live webcast February 6: DBOS Architect Chuck Bear walks you through the open source DBOS Transact for TypeScript 2.0 library. He'll show you the easiest way to make TypeScript, Next.js, Node.js apps durable, observable, and scalable by default.",
    },
    {
      property: 'og:image',
      content:
        'https://www.dbos.dev/assets/images/679b1023f3f6dad7d9729187_DBOS-Transact-2-TypeScript-Code-Walkthrough.jpg',
    },
    {
      name: 'twitter:title',
      content: 'Webcast: DBOS Transact for TypeScript 2.0',
    },
    {
      name: 'twitter:description',
      content:
        "Live webcast February 6: DBOS Architect Chuck Bear walks you through the open source DBOS Transact for TypeScript 2.0 library. He'll show you the easiest way to make TypeScript, Next.js, Node.js apps durable, observable, and scalable by default.",
    },
    {
      name: 'twitter:image',
      content:
        'https://www.dbos.dev/assets/images/679b1023f3f6dad7d9729187_DBOS-Transact-2-TypeScript-Code-Walkthrough.jpg',
    },
    {
      property: 'og:type',
      content: 'website',
    },
    {
      name: 'twitter:card',
      content: 'summary_large_image',
    },
  ],
  links: [
    {
      href: 'https://www.dbos.dev/webcast-dbos-transact-typescript-2',
      rel: 'canonical',
    },
  ],
  scripts: [],
};
